export default __webpack_public_path__ + "static/media/m_navBannerImg3.2a14289c.png";